module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 能否在微信小程序里使用")]), _vm._v(" "), _c('p', [_vm._v("Sorry，不能。微信小程序是个相对封闭的平台，无法简单地适配也没有计划支持小程序版本。")]), _vm._v(" "), _c('p', [_vm._v("目前企业主体用户可以使用 "), _c('code', [_vm._v("web-view")]), _vm._v(" 组件直接显示 web 页面，间接地使用 VUX。")]), _vm._v(" "), _c('h2', [_vm._v("mpvue 解决方案能否直接迁移 VUX")]), _vm._v(" "), _c('p', [_vm._v("目前 "), _c('a', {
    attrs: {
      "href": "http://mpvue.com/"
    }
  }, [_vm._v("mpvue")]), _vm._v(" 还不支持 "), _c('code', [_vm._v("slot")]), _vm._v("、"), _c('code', [_vm._v("slot-scope")]), _vm._v("，因此迁移有难度，并且小程序存在较多差异，暂未计划。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f318c6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4f318c6c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/can-vux-used-in-weapp-10.vue
// module id = 2233
// module chunks = 463